import { Printer, CalendarPlus, ChevronRight, Droplets } from "lucide-react";
import { toast } from "sonner";
import { buildPlanIcs, downloadIcs } from "../../lib/ics";
import { currentWeekIndex, fmtDate } from "../../lib/plan";
import { FOCUS_EVT } from "./JIrrigation";

const Milestones = ({ plan }) => (
  <div data-testid="plan-milestones" className="flex flex-wrap gap-2">
    {plan.milestones.map(([k, d], i) => {
      const last = i === plan.milestones.length - 1;
      return (
        <span key={k} data-testid={`plan-milestone-${i}`} className={`rounded-full px-3 py-1.5 text-xs border ${last ? "bg-[#F2B441] text-[#0E2A1C] border-[#F2B441] font-bold" : "bg-[#0E2A1C] border-[#F6EEDC]/15"}`}>
          <span className={last ? "" : "text-[#C9D6C2]"}>{k}:</span> <b className="capitalize">{fmtDate(d)}</b>
        </span>
      );
    })}
  </div>
);

const openIrrigation = (n) => window.dispatchEvent(new CustomEvent(FOCUS_EVT, { detail: n }));

const Row = ({ w, now }) => {
  const grow = w.phase === "Crecimiento";
  return (
    <li>
      <button onClick={() => openIrrigation(w.n)} data-testid={`plan-week-${w.n}`} aria-label={`Ver riegos de ${w.label}`}
        className={`group w-full text-left grid grid-cols-[auto_1fr_auto] items-center gap-3 rounded-[8px] px-3 py-2.5 border transition-colors ${now ? "bg-[#1B3A8C]/70 border-[#F2B441]" : "bg-[#0E2A1C] border-[#F6EEDC]/10 hover:border-[#F2B441]/70"}`}>
        <span className={`w-9 h-9 grid place-items-center rounded-full font-mono-d text-[11px] font-bold ${grow ? "bg-[#8CD05A]/20 text-[#8CD05A]" : "bg-[#F2B441]/20 text-[#F2B441]"}`}>{w.col}</span>
        <span className="min-w-0">
          <span className="flex flex-wrap items-center gap-x-2 text-sm font-bold">
            {w.label}
            <span className="font-normal text-xs text-[#C9D6C2] capitalize">{fmtDate(w.from)} – {fmtDate(w.to)}</span>
            {now && <span data-testid="plan-week-current" className="rounded-full bg-[#F2B441] text-[#0E2A1C] text-[10px] font-bold px-2 py-0.5">Esta semana</span>}
          </span>
          <span className="block text-xs text-[#E3EADF] mt-0.5 truncate">
            {w.doses.map((d) => `${d.name} ${d.dose}`).join(" · ") || "Solo agua"}{w.tasks[0] ? ` — ${w.tasks[0]}` : ""}
          </span>
        </span>
        <span className="inline-flex items-center gap-1 text-[11px] text-[#8FB0FF] group-hover:text-[#F2B441] transition-colors">
          <Droplets className="w-3.5 h-3.5" /><span className="hidden sm:inline">Riegos</span><ChevronRight className="w-3.5 h-3.5" />
        </span>
      </button>
    </li>
  );
};

export const JPlanTimeline = ({ plan, genetic }) => {
  const cur = currentWeekIndex(plan);
  const saveDates = () => {
    downloadIcs(buildPlanIcs(plan.milestones, genetic), "mi-cultivo-jungle.ics");
    toast.success(`${plan.milestones.length} fechas clave listas para tu calendario`, { description: "Abre el archivo descargado y pulsa Añadir todos. Aviso a las 9:00." });
  };
  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <p data-testid="plan-summary" className="text-sm text-[#C9D6C2]">
          <span className="font-serif-d font-black text-2xl text-[#F6EEDC] mr-2">{plan.total} semanas</span>
          toca una semana para ver sus riegos
        </p>
        <div className="flex flex-wrap gap-2">
          <button onClick={saveDates} data-testid="plan-calendar" className="inline-flex items-center gap-2 h-10 rounded-full bg-[#F2B441] text-[#0E2A1C] px-4 text-sm font-bold hover:bg-[#F6EEDC] transition-colors">
            <CalendarPlus className="w-4 h-4" /> Fechas al calendario
          </button>
          <button onClick={() => window.print()} data-testid="plan-print" className="inline-flex items-center gap-2 h-10 rounded-full border border-[#F6EEDC]/30 px-4 text-sm hover:border-[#F2B441] hover:text-[#F2B441] transition-colors">
            <Printer className="w-4 h-4" /> Imprimir
          </button>
        </div>
      </div>
      <Milestones plan={plan} />
      <ul data-testid="plan-weeks" className="space-y-1.5">
        {plan.weeks.map((w, i) => <Row key={w.n} w={w} now={i === cur} />)}
      </ul>
      <p className="text-xs text-[#C9D6C2]">Dosis en mL/L. El cuadrante de riego de abajo usa este mismo plan: misma fecha de inicio y misma duración.</p>
    </div>
  );
};
